export const TO_COMPLETE_INFO = 'complete_info';
export const TO_PAY_WAY = 'payway';
export const METRICS = {
  EXECUTOR: 'executor',
  EVENT: 'ticker',
  CATEGORY: {
    HOME: 'home',
  },
  ACTION: {
    TICKER: 'ticker',
  },
  LABEL: {
    OPEN_TELMEX: 'abrir - telmex',
    CLOSE_TELMEX: 'cerrar - telmex',
    OPEN_PAYMENT: 'abrir - suscripcion',
    CLOSE_PAYMENT: 'cerrar - suscripcion',
  },
};
